module.exports = __webpack_public_path__ + "static/media/jpg.0e66ca50.png";